import React from "react";
import { motion } from "framer-motion";
import { coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail31 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>「數論與密碼學」課程導覽</span>
        </h2>
        <p>
          資料安全與密碼學為近代資訊科技與演算法的熱門主題!!
          隨著資訊膨脹與商業交日益密集，政府部門、商業科技、網路安全等機構都需要位資料加密與驗證。信件加密、身分驗證、訊息加密與金鑰交換等重要資安主題都需要用到數論與密碼學的概念。
        </p>
        <p>
          這堂課程包含所有密碼學的系統設計與公式證明 - 包含「凱薩密碼」、「XOR
          Cipher」、「Poly alphabetic Cryptography」、「
          <span>RSA加密演算法</span>」、「
          <span>橢圓曲線加密演算法</span>
          」、「<span>DHKE金鑰交換</span>」與「身分驗證」等，還有更多重要概念。
        </p>
        <p>
          不論你的知識背景、數學能力、程式編寫能力為何，你都能夠學習此課程並成為資安驗證與密碼學演算法的老手。。詳細的解說與分析，所有公式皆有一步步的證明，演算法皆提供原始碼與教學，讓你不用花大錢，就能學到珍貴的資安演算法與公式。
        </p>
      </motion.div>
    </div>
  );
};

export default CoursesDetail31;
